import {
  CalendarCheck,
  CheckCircle2,
  CircleDollarSign,
  MessageCircle,
  Target,
  Construction
} from "lucide-react";

import { Summary } from "../../../../components/ui/Summary";
import { useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import {
  formatCurrency,
  formatNumber,
  formatPercent,
  safeDivide,
} from "../helpers";
import { MetricCard } from "../components/MetricCard";
import { SectionCard } from "../components/SectionCard";

export function DiagnosisSummary() {
  const kpis = useCrmPetDiagnosis((state) => state.data.overviewKpis);
  const contactedKpis = useCrmPetDiagnosis((state) => state.data.overviewContactedKpis);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const filters = useCrmPetDiagnosis((state) => state.data.filters.overview);

  const links = {
    crmRevenue: `/diagnosis/crm-pet?tab=results&resultsPeriod=${filters.period}&resultsFrom=${filters.from}&resultsTo=${filters.to}&resultsMinDays=${filters.minDays}&resultsStatus=FINISHED&resultsContacted=true`,
    serviceFinished: `/diagnosis/crm-pet?tab=results&resultsPeriod=${filters.period}&resultsFrom=${filters.from}&resultsTo=${filters.to}&resultsMinDays=${filters.minDays}&resultsStatus=FINISHED`
  }

  const operationMetrics = [
    {
      id: "crm-diagnosis-current-opportunities",
      icon: Target,
      value: formatNumber(kpis?.attempts),
      label: "Ausentes",
      loading: loading.overviewKpis,
      link: "/vendas/crm-pet",
    },
    {
      id: "crm-diagnosis-contacted-customers",
      icon: Construction,
      value: "Em breve",
      label: "Possíveis assinantes",
      loading: false,
    },
    {
      id: "crm-diagnosis-current-pending",
      icon: Construction,
      value: "Em breve",
      label: "Sem adicionais ",
      loading: false,
    },
    {
      id: "crm-diagnosis-contacts-made",
      icon: Construction,
      value: "Em breve",
      label: "Não compram produtos",
      loading: false,
    },
  ];

  const resultMetrics = [
    {
      id: "crm-diagnosis-contact-rate",
      icon: MessageCircle,
      value: formatPercent(safeDivide(contactedKpis?.attempts, kpis?.attempts)),
      label: "Clientes contatados",
      loading: loading.overviewKpis || loading.overviewContactedKpis,
    },
    {
      id: "crm-diagnosis-schedule-rate",
      icon: CalendarCheck,
      value: formatPercent(safeDivide(kpis?.scheduledCustomers, kpis?.attempts)),
      label: "Taxa de agendamento",
      loading: loading.overviewKpis,
    },
    {
      id: "crm-diagnosis-finished",
      icon: CheckCircle2,
      value: formatNumber(kpis?.finishedCustomers),
      label: "Agendamentos finalizados",
      loading: loading.overviewKpis,
      link: links.serviceFinished
    },
    {
      id: "crm-diagnosis-revenue",
      icon: CircleDollarSign,
      value: formatCurrency(kpis?.totalRevenue),
      label: "Receita atribuída ao CRM Pet",
      loading: loading.overviewKpis,
      link: links.crmRevenue
    },
  ];


  return (
    <div className="grid items-start gap-5 xl:grid-cols-2">
      <SectionCard
        title="Oportunidades"
        // description="Clientes "
        icon={Target}
      >
        <Summary.Root>
          {operationMetrics.map((metric) => (
            <MetricCard key={metric.id} {...metric} />
          ))}
        </Summary.Root>
      </SectionCard>

      <SectionCard
        title="Resultado"
        description="Efetividade da recuperação e valor atribuído ao CRM Pet no período."
        icon={CalendarCheck}
      >
        <Summary.Root>
          {resultMetrics.map((metric) => (
            <MetricCard key={metric.id} {...metric} />
          ))}
        </Summary.Root>
      </SectionCard>
    </div>
  );
}
